@defer (when value()) {
  <p-card>
    <ng-template pTemplate="header">
      <div class="p-card-title">
        {{ service.title() }}
      </div>
      <p-buttonGroup>
        @if (!detailed()) {
          <button
            pButton
            pRipple
            [label]="'Detalles'"
            icon="pi pi-info-circle"
            [title]="'Contract List Details'"
            (click)="routesService.list(resource)"
            class="p-button start"></button>
        }
        @if (access()?.permission?.actions?.create) {
          <button
            pButton
            pRipple
            [label]="'Nuevo'"
            icon="pi pi-user-plus"
            [title]="'Crate Contract'"
            (click)="routesService.create(resource)"
            class="p-button end"></button>
        }
      </p-buttonGroup>
    </ng-template>
    <p-table
      [value]="value() ?? []"
      [paginator]="true"
      [rows]="5"
      [rowsPerPageOptions]="[5, 10, 20]"
      [scrollable]="true"
      scrollHeight="flex">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th pSortableColumn="name" class="min-w-52">
            Nombre del Permiso <p-sortIcon field="name" />
          </th>
          @if (detailed()) {
            <th pSortableColumn="collectionName" class="min-w-48">
              Tipo de Colección <p-sortIcon field="collectionName" />
            </th>
            <th pSortableColumn="actions" class="min-w-52">
              Acciones Permitidas <p-sortIcon field="actions" />
            </th>
          }
          <th class="action">
            Acciones
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-value>
        <tr>
          <td>{{ value.name }}</td>
          @if (detailed()) {
            <td>{{ value.collectionName }}</td>
            <td>
              @if (value.actions;) {
                @for (action of value.actions; track $index) {
                  <p-chip [label]="$index + 1 + ' - ' + action.name"/>
                }
              } @else {
                {{ 'El permiso no tiene un acciones asignadas' }}
              }
            </td>
            <td>{{ value.created_by?.username ?? 'El usuario no tiene un contrato asignado' }}</td>
          }
          <td>
            <p-buttonGroup>
              <button
                pButton
                pRipple
                icon="pi pi-info-circle"
                [title]="value.name + ' details'"
                (click)="routesService.details(resource, value._id)">
              </button>
              @if (access()?.permission?.actions?.update) {
                <button
                  pButton
                  pRipple
                  icon="pi pi-user-edit"
                  [title]="value.name + ' edit'"
                  (click)="routesService.edit(resource, value._id)">
                </button>
              }
              @if (access()?.permission?.actions?.delete) {
                <button
                  pButton
                  pRipple
                  icon="pi pi-trash"
                  [title]="value.name + ' delete'"
                  (click)="routesService.delete(resource, value._id)">
                </button>
              }
            </p-buttonGroup>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-card>
}
